module.exports = {"411302001":"东关街道","411302002":"新华街道","411302003":"汉冶街道","411302004":"仲景街道","411302007":"赤虎街道","411302008":"五里堡街道","411302102":"官庄镇","411302103":"瓦店镇","411302104":"红泥湾镇","411302105":"黄台岗镇","411302106":"金华镇","411302107":"高庙镇","411302301":"溧河乡","411302302":"汉冢乡","411302304":"茶庵乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411302.json
// module id = 1638
// module chunks = 0